import { dayjs } from '../../../utils/dayjs-utils';
import { formatNumber } from '../../../utils/formattingUtils';
import { formatChallengeAmount } from '../../../utils/challenge-utils';
import { ChallengeApplicationPage } from '../../../types/challenges';

type ApplicationChallenge = ChallengeApplicationPage['challenge'];

export type ChallengeStat = { value: string; label: string };

const getRewardProductNames = (challenge: ApplicationChallenge) =>
  challenge.reward.type === 'free_product'
    ? challenge.reward.products
        .map(({ name }) => name)
        .filter(Boolean)
        .join(', ')
    : '';

export const getChallengeHeadline = (challenge: ApplicationChallenge, currency: string) => {
  const count = formatNumber(challenge.triggerValue);
  const action = challenge.metric === 'posts' ? `Post ${count} times` : `Reach ${count} ${challenge.metric}`;
  const reward =
    challenge.reward.type === 'flat_fee'
      ? formatChallengeAmount(challenge.reward.amountCents, currency)
      : `${getRewardProductNames(challenge) || 'a product'} free`;
  return `${action} and get ${reward}`;
};

export const getChallengeDescription = ({ challenge, brandName, instagramUsername }: ChallengeApplicationPage) => {
  const deadline = challenge.endDate ? ` before ${dayjs(challenge.endDate).format('D MMM, YYYY')}` : '';
  return `Tag @${instagramUsername} in each post${deadline}. ${brandName} reviews every application.`;
};

export const getChallengeStats = (challenge: ApplicationChallenge, currency: string, isMobile: boolean) => {
  const stats: ChallengeStat[] = [
    {
      value: formatNumber(challenge.triggerValue),
      label: challenge.metric === 'posts' ? 'posts to make' : `${challenge.metric} to reach`,
    },
    challenge.reward.type === 'flat_fee'
      ? { value: formatChallengeAmount(challenge.reward.amountCents, currency), label: 'reward' }
      : { value: 'Free', label: 'product' },
  ];
  if (challenge.endDate) {
    stats.push({ value: dayjs(challenge.endDate).format('D MMM'), label: isMobile ? 'ends on' : 'last date' });
  }
  return stats;
};

export const getCountryFlag = (countryCode: string) =>
  String.fromCodePoint(
    ...countryCode
      .toUpperCase()
      .split('')
      .map((char) => 127397 + char.charCodeAt(0))
  );
